import Section50BisReportComponent from "features/Report/components/SalaryGroup/Section50BisReport";
import useSection50BisReport from "features/Report/hooks/salaryGroup/useSection50BisReport";

const Section50BisPage = () => {
    const section50bisReportProps = useSection50BisReport();
    return <Section50BisReportComponent {...section50bisReportProps} />
}

export default Section50BisPage;